// Use Environment Variables (Vite)
// Fallback to localhost if not set (for safety during migration) but encourage .env usage
// Use Environment Variables (Vite)
const isLocal = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const APP_BASE_URL = (import.meta.env.VITE_APP_URL && import.meta.env.VITE_APP_URL.trim() !== '')
    ? import.meta.env.VITE_APP_URL
    : (isLocal ? 'http://localhost:5173' : 'https://app.lewotobi.com');

export const MARKETING_BASE_URL = (import.meta.env.VITE_WEB_URL && import.meta.env.VITE_WEB_URL.trim() !== '')
    ? import.meta.env.VITE_WEB_URL
    : (isLocal ? 'http://localhost:5174' : 'https://lewotobi.com');
